import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spinner } from "@telegram-apps/telegram-ui";
import { api } from "../../lib/api.js";
import { usePageBack } from "../../lib/telegram.js";

const PAGE_SIZE = 50;

export default function UsersList() {
  const navigate = useNavigate();
  usePageBack("/superadmin");
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const offset = Number(params.get("offset") || 0);
  const [draft, setDraft] = useState(q);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setData(null);
    const qs = new URLSearchParams({ q, limit: String(PAGE_SIZE), offset: String(offset) });
    api(`/api/v1/superadmin/users?${qs}`)
      .then(setData)
      .catch((e) => setError(e.message));
  }, [q, offset]);

  const submitSearch = (e) => {
    e?.preventDefault?.();
    const next = new URLSearchParams();
    if (draft) next.set("q", draft);
    setParams(next, { replace: true });
  };

  return (
    <>
      <section className="portal-card">
        <header className="portal-card__header">
          <h2 className="portal-card__title">Пилоты</h2>
          {data && <span className="portal-card__hint">Найдено: {data.total}</span>}
        </header>
        <form onSubmit={submitSearch} className="portal-search">
          <SearchIcon />
          <input
            type="search"
            placeholder="Имя, @username или Telegram ID"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={submitSearch}
          />
        </form>
      </section>

      {!data && !error && (
        <div className="portal-card" style={{ display: "flex", justifyContent: "center" }}>
          <Spinner size="m" />
        </div>
      )}
      {error && <div className="portal-card"><p className="portal-empty">Ошибка: {error}</p></div>}

      {data?.users?.length === 0 && (
        <div className="portal-card"><p className="portal-empty">Никого не нашли.</p></div>
      )}

      {data?.users?.length > 0 && (
        <div className="portal-list">
          {data.users.map((u) => {
            const name =
              [u.last_name, u.first_name, u.middle_name].filter(Boolean).join(" ") || "(без имени)";
            const handle = u.tg_username ? `@${u.tg_username}` : `tg:${u.tg_user_id}`;
            const initials = (u.first_name?.[0] || u.tg_username?.[0] || "?").toUpperCase();
            return (
              <button
                key={u.id}
                type="button"
                className="portal-list__row"
                onClick={() => navigate(`/superadmin/users/${u.id}`)}
              >
                <div className="portal-list__avatar">{initials}</div>
                <div className="portal-list__body">
                  <div className="portal-list__title">
                    {name}
                    {u.is_superadmin && <span className="portal-badge portal-badge--info">SUPER</span>}
                  </div>
                  <div className="portal-list__sub">{handle} · #{u.id}</div>
                </div>
                <div className="portal-list__after">→</div>
              </button>
            );
          })}
        </div>
      )}

      {data && data.total > PAGE_SIZE && (
        <div className="portal-pager">
          <button
            type="button"
            className="portal-pager__btn"
            disabled={offset === 0}
            onClick={() => {
              const next = new URLSearchParams(params);
              next.set("offset", String(Math.max(0, offset - PAGE_SIZE)));
              setParams(next, { replace: true });
            }}
          >← Назад</button>
          <span>{offset + 1}–{Math.min(offset + PAGE_SIZE, data.total)} из {data.total}</span>
          <button
            type="button"
            className="portal-pager__btn"
            disabled={offset + PAGE_SIZE >= data.total}
            onClick={() => {
              const next = new URLSearchParams(params);
              next.set("offset", String(offset + PAGE_SIZE));
              setParams(next, { replace: true });
            }}
          >Дальше →</button>
        </div>
      )}
    </>
  );
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="7" cy="7" r="5" />
      <path d="m11 11 3 3" strokeLinecap="round" />
    </svg>
  );
}
